<template>
    <div class="list-raovat list-raovat-epxired">
        <fillterExp
        v-model="data_fillter"
        :arrPromotionStatus="arrPromotionStatus"
        :idSelect="idSelect"/>
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col" class="text-center">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                id="select-all-table" v-model="selectAll"/>
                            <label class="custom-control-label" for="select-all-table"></label>
                        </div>
                    </th>
                    <th scope="col" class="text-center">Ảnh</th>
                    <th scope="col">Tiều đề</th>
                    <!-- <th scope="col">Thuộc tính</th> -->
                    <th scope="col">Giá trước khuyến mại</th>
                    <th scope="col">Giá khuyến mại</th>
                    <th scope="col">Thời gian</th>
                    <th scope="col">Số lượng</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col" class="text-center">Thao tác</th>
                </tr>
            </thead>
            <thead v-else>
                <tr>
                    <th scope="col" class="text-center py-1">
                        <span class="check-all-mobile" @click="selectAll = !selectAll">
                            <img :src="selectAll ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                        </span>
                    </th>
                    <th scope="col" class="text-center py-1">Thông tin</th>
                </tr>
            </thead>
            <tbody v-if="proPromotion.length == 0">
                <tr>
                    <td colspan="12" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
            </tbody>
            <tbody v-else-if="$detect == 'web'">
                <tr class="position-relative" v-for="(item,index) in proPromotion" :key="index">
                    <td scope="row" style="white-space: nowrap;">
                        <div class="custom-control custom-checkbox text-center">
                            <input type="checkbox" class="custom-control-input"
                                :value="item.id" :id="item.id" v-model="idSelect"/>
                            <label class="custom-control-label" :for="item.id"></label>
                        </div>
                    </td>
                    <td width="50" class="position-relative">
                        <img class="img-web" :src="item.image" onerror="errorImage(this)"/>
                    </td>
                    <td class="name-rv">
                        <div>
                            <a class="text-decoration-none" :href="$linkUrl(item.link)" target="_blank">
                                <span class="pr-2 id-table">#{{ item.id }}</span><span class="name-item">{{ item.name }}</span>
                            </a>
                             <div v-if="arrDataSizeColor[item.prp_size_color_id]" class="text-primary">
                                {{ arrSize[arrDataSizeColor[item.prp_size_color_id]['pscd_size_id']] ? arrSize[arrDataSizeColor[item.prp_size_color_id]['pscd_size_id']].ps_name+' - ' : ''}}
                                {{ arrColorS[arrDataSizeColor[item.prp_size_color_id]['pscd_color_id']] ? arrColorS[arrDataSizeColor[item.prp_size_color_id]['pscd_color_id']].pc_name : ''}}
                            </div>
                        </div>
                    </td>
                   <!--  <td width="100" class="position-relative">
                        <div v-if="arrDataSizeColor[item.prp_size_color_id]">
                            {{ arrSize[arrDataSizeColor[item.prp_size_color_id]['pscd_size_id']] ? arrSize[arrDataSizeColor[item.prp_size_color_id]['pscd_size_id']]['ps_name']+' - ' : ''}}
                            {{ arrColorS[arrDataSizeColor[item.prp_size_color_id]['pscd_color_id']] ? arrColorS[arrDataSizeColor[item.prp_size_color_id]['pscd_color_id']]['pc_name'] : ''}}
                        </div>
                    </td> -->
                    <td width="100" class="position-relative">
                        <p class="mb-0 text-danger fw-600" v-html="item.prp_price_old"></p>
                    </td>
                    <td width="100" class="position-relative">
                        <p class="mb-0 text-danger fw-600" v-html="item.prp_price_promotion"></p>
                    </td>
                    <td width="120" class="position-relative text-center">
                        <p class="mb-0 fw-400 font-12px">{{ item.prp_date_start }}</p>
                        <p class="mb-0 fw-600 ">{{ item.prp_date_end }}</p>
                    </td>
                    <td width="100" class="position-relative text-center">
                        <p class="mb-0 fw-600">{{ item.prp_quantity <= 1 ? 'Theo số lượng trong kho' : item.prp_quantity}}</p>
                    </td>
                     <td width="100" class="position-relative">
                        <p :class="{
                                'mb-0 fw-600' : true,
                                'text-warning' : item.status == 1,
                                'text-primary' : item.status == 2,
                                'text-success' : item.status == 4,
                                'text-oranges' : item.status == 3,
                                'text-danger' : item.status == 5 || item.status == 6,
                                'text-secondary' : item.status == 7,

                            }">{{ arrPromotionStatus[item.status] }}</p>
                    </td>
                    <td width="180" class="text-center">
                        <button type="button" class="btn btn-primary btn-sm px-3 mr-2"
                            @click="sale(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                             <i class="icon ion-md-create"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destrory(item, index)" :disabled="index === loading && loadingAction == 'destrory'">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="table-mobile" v-for="(item, index) in proPromotion" :key="index">
                    <td class="img-tab position-relative pl-1">
                        <div class="checkbox-mobile position-absolute">
                            <input type="checkbox" class="d-none" v-model="idSelect"
                                :value="item.id" :id="item.id"/>
                            <label class="checkbox-label" :for="item.id">
                                <img :src="idSelect.includes(item.id) ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                            </label>
                        </div>
                        <div>
                            <img :src="item.image" onerror="errorImage(this)" @click="pushIdMuti(item)"/>
                        </div>
                    </td>
                    <td>
                        <div class="name">
                            <a class="text-decoration-none" :href="item.link" target="_blank">
                                <span class="name-item">{{ item.name }}</span>
                            </a>
                        </div>
                        <div class="text-primary" style="height: 19px;">
                            <span v-if="arrDataSizeColor[item.prp_size_color_id]">
                                {{ arrSize[arrDataSizeColor[item.prp_size_color_id]['pscd_size_id']] ? arrSize[arrDataSizeColor[item.prp_size_color_id]['pscd_size_id']].ps_name+' - ' : ''}}
                                {{ arrColorS[arrDataSizeColor[item.prp_size_color_id]['pscd_color_id']] ? arrColorS[arrDataSizeColor[item.prp_size_color_id]['pscd_color_id']].pc_name : ''}}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <span class="price-tab mr-2" v-html="item.prp_price_promotion"></span>
                                <span class="price-tab-old" v-html="item.prp_price_old"></span>
                            </div>
                            <div>
                                <span :class="{
                                    'mb-0 fw-600 text-promotion ' : true,
                                    'text-warning' : item.status == 1,
                                    'text-primary' : item.status == 2,
                                    'text-success' : item.status == 4,
                                    'text-oranges' : item.status == 3,
                                    'text-danger' : item.status == 5 || item.status == 6,
                                    'text-secondary' : item.status == 7,

                                }">{{ arrPromotionStatus[item.status] }}</span>
                            </div>
                            
                            
                        </div>
                         <!-- <div class="d-flex justify-content-between mt-2">
                            <div class="price-tab" v-html="item.price"></div>
                        </div>
                         <div class="d-flex justify-content-between mt-2">
                            <div class="price-tab" v-html="item.price"></div>
                        </div>
                         <div class="d-flex justify-content-between mt-2">
                            <div class="price-tab" v-html="item.price"></div>
                        </div> -->
                        <div class="mt-2">
                            <button type="button"
                                class="btn btn-primary btn-sm mr-2 w-btn"
                                @click="sale(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                                Sửa
                            </button>
                            <button type="button" class="btn btn-danger btn-sm ml-2 w-btn"
                                @click="destrory(item, index)" :disabled="index === loading && loadingAction == 'destrory'">
                                Xoá
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getPromotion"/>
    </div>
</template>

<script>
import { availability, destroy } from '@/config/product';
export default {
    components: {
        fillterExp: () => import('./fillter.vue'),
        paginate: () => import('@/components/layout/pagination.vue'),
    },
    data() {
        return {
            proPromotion: [],
            idSelect: [],
            last_page: 0,
            next_page: 0,
            current_page: 0,
            data_fillter: {
                status: 0,
                keyword: '',
            },
            selectAll: false,
            loading: '',
            loadingAction: '',
            arrColorS : [],
            arrSize : [],
            arrSubColor : [],
            arrPromotionStatus : [],
            arrDataSizeColor : [],

        }
    },
    created() {
        this.getPromotion(1);
        this.$eventBus.$on('call-page-expire', () => {
            this.idSelect = [];
            this.getDataAction(this.current_page);
        });
    },
    methods: {
        getPromotion(page) {
            let params = {
                page: page,
                status: this.data_fillter.status,
                keyword: this.data_fillter.keyword,
            };
            this.idSelect = [];
            this.selectAll = false;
            apiGet('v2/profile/products/get_promotion', params).then(res => {
                this.proPromotion = res.data.arrProduct.data;
                this.last_page = res.data.arrProduct.last_page;
                this.next_page = res.data.arrProduct.next_page;
                this.current_page = res.data.arrProduct.current_page;
                this.selectAll = false;
                this.arrColorS =  res.data.arrColorS;
                this.arrSize = res.data.arrSize;
                this.arrSubColor = res.data.arrSubColor;
                this.arrPromotionStatus = res.data.arrPromotionStatus;
                this.arrDataSizeColor = res.data.arrDataSizeColor;
            })
        },
        async sale(item, index = null){
            this.loading = index;
            this.loadingAction = 'availability';
            this.$router.push({
                name: 'product-action-product-sale',
                query: {
                    id: item.id
                }
            })
            // await availability([item.id], this);
            this.loading = '';
            this.loadingAction = '';
            await this.getDataAction(this.current_page);
        },
        async destrory(item, index = null){
            this.loading = index;
            this.loadingAction = 'destrory';
            await destroy(item.id, this);
            this.loading = '';
            this.loadingAction = '';
            await this.getDataAction(this.current_page);
        },
        async getDataAction(page){
            if(page < 1) return;
            let params = {
                page: page,
                status: this.data_fillter.status,
                keyword: this.data_fillter.keyword,
            };
            this.idSelect = [];
            this.selectAll = false;
            let data = {};
            await apiGet('v2/profile/products/get_promotion', params).then(res => {
                if(res.data.current_page == 1){
                    this.proPromotion = res.data.arrProduct.data;
                    this.last_page =  res.data.arrProduct.last_page;
                    this.next_page =  res.data.arrProduct.next_page;
                    this.current_page =  res.data.arrProduct.current_page;
                    this.arrColorS =  res.data.arrColorS;
                    this.arrSize = res.data.arrSize;
                    this.arrSubColor = res.data.arrSubColor;
                    this.arrPromotionStatus = res.data.arrPromotionStatus;
                    this.arrDataSizeColor = res.data.arrDataSizeColor;
                }
                data = res.data;
            });
            if(data.arrProduct.data.length == 0){
                this.getDataAction(page - 1);
            }else{
                this.proPromotion = data.data;
                this.last_page = data.last_page;
                this.next_page = data.next_page;
                this.current_page = data.current_page;
            }
        }
    },
    watch: {
        data_fillter: {
            handler(val){
                this.getPromotion(1)
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.proPromotion.map(item => {
                    this.idSelect.push(item.id);
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.proPromotion.map(item => {
                    count += 1;
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
    }
}
</script>

<style lang="scss">
    .font-12px{
        font-size: 12px;
    }
    .text-oranges{
        color : #fd7e14;
    }
    .table-mobile {
        .w-btn {
            width: calc( 50% - 8px );
        }
        .checkbox-mobile {
            top: 19px !important;
            left: 7px !important;
        }
    }
    .price-tab-old{
        margin-top: 3px;
        font-size: 12px;
        text-decoration-line: line-through;
        color: #6c757d;
    }
    .text-promotion{
        margin-top: 3px;
        font-size: 11px;
    }
</style>
